import { white100 } from 'ext-ui/style/colors'
import { createGlobalStyle } from 'styled-components'

// Class names for the legacy Popup card. The defaults below reproduce the
// pre-migration white box (width, padding, responsive breakpoints) so Popup keeps
// its look, and BaseModal renders a bare body (`unstyledBody`) around this card —
// keeping consumer css/className overrides on a single box.
export const POPUP_CARD_CLASS = 'Popup-card'
export const POPUP_CARD_NO_PADDING_CLASS = 'Popup-card-noPadding'

// Legacy box dimensions (styleConstants.widths.popup / borderRadius.box) and
// breakpoints (XSM / XXSM), inlined so this style module has no module-load
// dependency on @paywithextend/components — that import is mocked incompletely in
// several test suites, and createGlobalStyle evaluates its interpolations eagerly.
const POPUP_CARD_WIDTH = '700px'
const POPUP_CARD_RADIUS = '10px'
const XSM_DOWN = '@media (max-width: 767px)'
const XXSM_ONLY = '@media (max-width: 567px)'

// The defaults are emitted via createGlobalStyle as `:where(.Popup-card){…}`,
// which carries ZERO specificity (no styled-component hash prefix). A single
// consumer class on the same element — forwarded here from `<Popup css={…}>` /
// `className` — therefore overrides width/padding deterministically, regardless of
// stylesheet insertion order. (A styled-component's `:where(&)` would still emit a
// `.hash` prefix at specificity 0,1,0, only tying a consumer class.) Rendering this
// component per-Popup is safe: styled-components de-duplicates the injection.
export const PopupCardGlobalStyle = createGlobalStyle`
  :where(.${POPUP_CARD_CLASS}) {
    box-sizing: border-box;
    background-color: ${white100};
    border-radius: ${POPUP_CARD_RADIUS};
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
    width: ${POPUP_CARD_WIDTH};
    padding: 60px;

    ${XSM_DOWN} {
      width: 100%;
      padding: 40px;
    }

    ${XXSM_ONLY} {
      padding: 40px 20px;
    }
  }

  :where(.${POPUP_CARD_NO_PADDING_CLASS}) {
    padding: 0;
  }
`
